import { createContext, ReactNode, useContext, useState } from 'react'

interface CanSubmitContextType {
    canSubmit: boolean
    setCanSubmit: (value: boolean) => void
}

const CanSubmitContext = createContext<CanSubmitContextType | undefined>(
    undefined,
)

export function CanSubmitProvider({ children }: { children: ReactNode }) {
    const [canSubmit, setCanSubmit] = useState(true)

    return (
        <CanSubmitContext.Provider value={{ canSubmit, setCanSubmit }}>
            {children}
        </CanSubmitContext.Provider>
    )
}

export function useCanSubmit() {
    const context = useContext(CanSubmitContext)
    if (context === undefined) {
        throw new Error(
            'useCanSubmit deve ser usado dentro de um CanSubmitProvider',
        )
    }
    return context
}
